"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function isStyleProps(styleArgument) {
    if (!!styleArgument && typeof styleArgument === 'object' && !Array.isArray(styleArgument)) {
        return styleArgument.hasOwnProperty('style') && styleArgument.hasOwnProperty('className');
    }
    return false;
}
function mergeClassNames(target, cls) {
    if (!cls || !cls.length) {
        return target;
    }
    return target.length === 0
        ? cls
        : target + " " + cls;
}
function mergeStyleProperties(target, style) {
    return tslib_1.__assign({}, target, style);
}
function mergerStyleConfigs(target, style) {
    return {
        className: mergeClassNames(target.className, style.className),
        style: mergeStyleProperties(target.style, style.style),
    };
}
// tslint:disable-next-line:no-any
function isStyleConifg(target) {
    if (!target) {
        return false;
    }
    return typeof target === 'object' || typeof target === 'string';
}
function reducer(acc, style) {
    if (!isStyleConifg(style)) {
        return acc;
    }
    if (Array.isArray(style)) {
        return style.reduce(reducer, acc);
    }
    if (typeof style === 'object') {
        return isStyleProps(style)
            ? mergerStyleConfigs(acc, style)
            : mergerStyleConfigs(acc, { className: '', style: style });
    }
    acc.className = mergeClassNames(acc.className, style);
    return acc;
}
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reducer, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;
